<template>
  <div class="banner" :class="cssType + ' ' + locale">
    <div v-if="cssType === 'mobile'" class="logo" :class="locale"></div>
    <div class="main-title" :class="locale"></div>
  </div>
</template>

<script setup>
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
</script>

<style scoped lang='less' src='./pc_style.less'></style>
<style scoped lang='less' src='./mobile_style.less'></style>